import React from 'react';
import InternalPhoneInput from 'react-phone-input-2';

import { StyledPhoneInput } from './PhoneInput.styled';

interface StandaloneProps {
  disabled?: boolean;
  name: string;

  /** Call back when you no longer focus on the input */
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;

  /** When input data changes */
  onChange?: (value: string | number) => void;
}

export default function Standalone(props: StandaloneProps) {
  const { disabled, name, onBlur, onChange, ...inputProps } = props;

  function phoneOnChange(value: string) {
    if (onChange) {
      onChange(value);
    }
  }

  return (
    <StyledPhoneInput>
      <InternalPhoneInput
        enableSearch
        disabled={disabled}
        inputProps={{ name }}
        onBlur={onBlur}
        onChange={phoneOnChange}
        {...inputProps}
      />
    </StyledPhoneInput>
  );
}

Standalone.defaultProps = {
  disabled: false,
  name: null,
  onBlur: undefined,
  onChange: undefined,
};
